import router from './router'
import store from './stores'
import { getParams } from '@/utils/auth'

// const whiteList = ['/login'] // 不重定向白名单

// 添加路由守卫
router.beforeEach((to, from, next) => {
  let dataBase = getParams('database')
  if (dataBase) {
    store.commit('SET_DATA_BASE', decodeURIComponent(dataBase))
  } else {
    store.commit('SET_DATA_BASE', '贵州数据库')
  }
  if (to.path !== 'detail' && !store.getters.listCatalogName) {
    let token = localStorage.getItem('token')
    if (token) {
      store.dispatch('GetSearchFilter').finally(_ => {
        next()
      })
    } else {
      next()
    }
  } else {
    next()
  }
})
